import React, { useMemo, useCallback } from 'react';
import { Menu } from 'antd';
const { SubMenu } = Menu;
import { timeOutRequest } from '../util';
import LoadingOutlined from '@ant-design/icons/LoadingOutlined';
import useDebounceForEvent from '@web-mail/hooks/useDebounceForEvent';
import { getMailFromMails, trans2DomPropsObj } from '@web-mail/util';
import useCreateCallbackForEvent from '@web-mail/hooks/useCreateCallbackForEvent';
const EmptyList = [];
const MailMenuRender = props => {
    const { data = EmptyList, mailData, onMenuClick, menuItemStateMap, onMenuItemStateChange, beforeMenuClick, domProps } = props;
    const getDomPropsObject = useCreateCallbackForEvent((mails, menuConfig) => {
        return trans2DomPropsObj(domProps, mails, menuConfig);
    });
    const getElement = useCallback((params) => {
        if (typeof params === 'function') {
            return params(mailData);
        }
        return params;
    }, [mailData]);
    const getMenuItemContent = useCallback((item, isLoading) => {
        const domProps = getDomPropsObject(mailData, item) || {};
        return item.render != null ? (item.render(mailData)) : (React.createElement("div", Object.assign({ className: "menu-content-wrap" }, domProps),
            isLoading ? (React.createElement("div", { style: { marginRight: 10 } },
                React.createElement(LoadingOutlined, { style: { fontSize: '16px' } }))) : null,
            React.createElement("div", { className: "menu-name" }, getElement(item.name)),
            React.createElement("div", { className: "menu-icon" }, getElement(item.tip))));
    }, [mailData, getDomPropsObject]);
    const getSubMenuItem = useCallback((params, parentIndex = 0) => {
        if (typeof params === 'function') {
            return params(mailData, onMenuClick);
        }
        let preGroup = null;
        return getCouldShowMenu(params).map((item, index) => {
            if (item.subMenus) {
                const res = getSubMenu(item, parentIndex + '' + index, index == 0 ? null : preGroup);
                preGroup = item === null || item === void 0 ? void 0 : item.group;
                return res;
            }
            const res = getMenuItem(item, parentIndex + '' + index, index == 0 ? null : preGroup);
            preGroup = item === null || item === void 0 ? void 0 : item.group;
            return res;
        });
    }, [mailData]);
    const getSubMenu = useCallback((params, index, prevGroup) => {
        const subMenuItem = getSubMenuItem(params.subMenus);
        if (Array.isArray(subMenuItem) && subMenuItem.length === 0) {
            return null;
        }
        const key = params.key ? params.key + '' : '';
        const testId = key && key.includes('-') ? key.split('-').pop() : key;
        return (React.createElement(React.Fragment, null,
            index != 0 && prevGroup && prevGroup != params.group ? React.createElement(Menu.Divider, { key: `divider-${params.key ? params.key : index}` }) : null,
            React.createElement(SubMenu, { "data-test-id": 'mail-menu-' + testId, key: params.key ? params.key : index, title: getMenuItemContent(params), popupOffset: [1, 0] }, subMenuItem)));
    }, [getMenuItemContent, getSubMenuItem]);
    const handleMenuItemClick = useCallback((item) => {
        try {
            if (beforeMenuClick) {
                beforeMenuClick(item, mailData);
            }
        }
        catch (e) {
            console.error('[error handleMenuItemClick beforeMenuClick]', e);
        }
        onMenuClick && onMenuClick(false);
        if (item.onClick) {
            let task = item.onClick(mailData);
            if (task === null || task === void 0 ? void 0 : task.then) {
                try {
                    task = timeOutRequest(task, 15000);
                    onMenuItemStateChange && onMenuItemStateChange(item.key + '', true);
                    task === null || task === void 0 ? void 0 : task.finally(() => {
                        onMenuItemStateChange && onMenuItemStateChange(item.key + '', false);
                    });
                }
                catch (e) {
                    console.error('[MailMenuRender syncMenu Error]:', e);
                    onMenuItemStateChange && onMenuItemStateChange(item.key + '', false);
                }
            }
        }
    }, [onMenuClick, onMenuItemStateChange, mailData]);
    const dbHandleMenuItemClick = useDebounceForEvent(handleMenuItemClick, 500, {
        leading: true,
        trailing: false,
        maxWait: 500,
    });
    const getMenuItem = useCallback((item, index, prevGroup) => {
        var _a;
        const mail = getMailFromMails(mailData);
        const mailMenuConfig = menuItemStateMap && menuItemStateMap[(_a = mail === null || mail === void 0 ? void 0 : mail.entry) === null || _a === void 0 ? void 0 : _a.id];
        const isLoading = !!(mailMenuConfig && mailMenuConfig[(item === null || item === void 0 ? void 0 : item.key) + '']);
        return (React.createElement(React.Fragment, null,
            index != 0 && prevGroup != item.group ? React.createElement(Menu.Divider, { key: `divider-${item.key ? item.key : index}` }) : null,
            React.createElement(Menu.Item, { key: item.key ? item.key : index, disabled: isLoading, onClick: () => {
                    !isLoading && dbHandleMenuItemClick(item);
                } }, getMenuItemContent(item, isLoading))));
    }, [getMenuItemContent, mailData, onMenuClick, menuItemStateMap]);
    const getCouldShowMenu = useCallback((data) => {
        return data.filter(item => {
            const { show = true } = item;
            if (typeof show === 'function') {
                if (mailData) {
                    return show(mailData);
                }
                return false;
            }
            return show;
        });
    }, [mailData]);
    const Element = useMemo(() => {
        let prevGroup = '';
        return mailData ? (React.createElement(Menu, { selectable: false }, getCouldShowMenu(data).map((item, index) => {
            if (item.subMenus) {
                const res = getSubMenu(item, index, index == 0 ? null : prevGroup);
                prevGroup = item === null || item === void 0 ? void 0 : item.group;
                return res;
            }
            const res = getMenuItem(item, index, index == 0 ? null : prevGroup);
            prevGroup = item === null || item === void 0 ? void 0 : item.group;
            return res;
        }))) : (React.createElement(React.Fragment, null));
    }, [data, mailData]);
    return Element;
};
export default MailMenuRender;
